import React, { useState } from 'react';
import { BOTTOM_INDENTS, COLORS } from '@constants';
import { useStore } from '@hooks';
import { Button, Typography } from '@ui';
import { Flex } from 'antd';
import { observer } from 'mobx-react';

const DeleteModal = observer(({ member, close, fullName }) => {
    const store = useStore();
    const { handleTeamMemberDelete } = store.accountsStore;
    const [loading, setLoading] = useState(false);

    const submitDelete = async () => {
        setLoading(true);
        try {
            await handleTeamMemberDelete(member);
        } finally {
            setLoading(false);
            close();
        }
    };

    return (
        <React.Fragment>
            <Typography.Text style={BOTTOM_INDENTS.S} data-e2e='team-management_delete-modal_description'>
                Are you sure you want to delete <span style={{ fontWeight: 500 }}>{fullName}</span> from your store?
            </Typography.Text>
            <Typography.Text style={BOTTOM_INDENTS.M}>This action cannot be undone.</Typography.Text>
            <Flex justify='flex-end' align='center' gap={16}>
                <Button
                    onClick={close}
                    style={{ width: 160 }}
                    backgroundColor={COLORS.$white}
                    block
                    data-e2e='team-management_delete-modal_cancel_btn'
                >
                    Cancel
                </Button>
                <Button
                    loading={loading}
                    onClick={submitDelete}
                    type='primary'
                    style={{ width: 160 }}
                    data-e2e='team-management_delete-modal_delete_btn'
                >
                    Yes, Delete
                </Button>
            </Flex>
        </React.Fragment>
    );
});

export default DeleteModal;
